module.exports = __webpack_public_path__ + "img/ld1.deecbe00.jpg";